import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { LoginPasswordDTO, MfaCodeModel, RefreshTokenDTO } from '../models/login';

@Injectable({
  providedIn: 'root'
})
export class LoginPasswordService {


  private pathAPI = environment.urlAPI;
  private controller = "Login/";

  constructor(private http: HttpClient) { }


  public GeneratePasswordLink(data: LoginPasswordDTO): Observable<boolean> {
    return this.http.post<boolean>(this.pathAPI + this.controller + "GeneratePasswordLink", data);
  }

  public GetPasswordKey(key, idUser): Observable<LoginPasswordDTO> {
    return this.http.get<LoginPasswordDTO>(this.pathAPI + this.controller + "GetPasswordKey/" + key + "/" + idUser);
  }

  public CreatePassword(data: LoginPasswordDTO): Observable<LoginPasswordDTO> {
    return this.http.post<LoginPasswordDTO>(this.pathAPI + this.controller + "CreatePassword", data);
  }

  //#region 2FA

  public GenerateTwoFactorQr(idUser: string): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + "GenerateTwoFactorQr/" + idUser);
  }

  public EnabledTwoFactorCode(data: MfaCodeModel): Observable<LoginPasswordDTO> {
    return this.http.post<LoginPasswordDTO>(this.pathAPI + this.controller + "EnabledTwoFactorCode", data);
  }

  public TotpPassword(data: MfaCodeModel): Observable<RefreshTokenDTO> {
    return this.http.post<RefreshTokenDTO>(this.pathAPI + this.controller + "TotpPassword", data);
  }

  //#endregion
}
